import { render, staticRenderFns } from "./ventasacumuladas.vue?vue&type=template&id=5789a13c"
import script from "./ventasacumuladas.vue?vue&type=script&lang=js"
export * from "./ventasacumuladas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports